var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-323e8162]{margin-bottom:12px;font-family:Open Sans,sans-serif;-ms-transform:translateY(-9px);transform:translateY(-9px)}.header__link[data-v-323e8162]{margin-bottom:6px;width:127px;height:13px;font-size:10px;font-weight:600;color:#8163a6;text-decoration:none;text-transform:uppercase;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.header__link[data-v-323e8162]:before{content:\"\";display:inline-block;width:29px;height:13px;background:url(" + escape(require("./images/back.svg")) + ") no-repeat}.header__name[data-v-323e8162]{font-size:20px;font-weight:300}@media only screen and (min-width:475px){.header__name[data-v-323e8162]{font-size:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-323e8162","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/progress/components/header/Header.vue
// module id = 925126a71463a3824d01
// module chunks = 11